import { useState } from "react";
import { FaUser, FaLock, FaEnvelope } from "react-icons/fa";
import "../../Styles/Login.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { Link } from "react-router-dom";

export default function SignUp() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Signup Data:", formData);
  };

  return (<div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
        <div className="login-container">
          <h2 className="login-title">Create an Account</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group1">
              <label>Full Name</label>
              <div className="input-container">
                <FaUser className="icon" />
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  required
                />
              </div>
            </div>

            <div className="input-group1">
              <label>Email Address</label>
              <div className="input-container">
                <FaEnvelope className="icon" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div className="input-group1">
              <label>Password</label>
              <div className="input-container">
                <FaLock className="icon" />
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                />
              </div>
            </div>

            <div className="input-group1">
              <label>Confirm Password</label>
              <div className="input-container">
                <FaLock className="icon" />
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  placeholder="Confirm your password"
                  required
                />
              </div>
            </div>

            <button type="submit" className="login-button">
              Sign Up
            </button>
          </form>

          <div className="extra-links">
            <p>
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>
    </div>
  );
}
